export default "<app-accent-button [scrollToTop]=\"true\" position=\"center\" class=\"flex justify-center\">\n    Wieder nach oben\n</app-accent-button>\n";